<template>
  <template v-for="(piece, i) in pieces" :key="i"><strong v-if="piece.strong" class="amount">{{ piece.text }}</strong><template v-else>{{ piece.text }}</template></template>
</template>

<script>
// A line of recipe text with its amounts, times and temperatures in bold
// (utils/readable.js), so the eye lands on the numbers.
import { computed } from 'vue';
import { emphasize } from '../utils/readable.js';

export default {
  name: 'Amounts',
  props: { text: { type: String, default: '' } },
  setup (props) {
    return { pieces: computed(() => emphasize(props.text)) };
  }
};
</script>
